export class CuentaFilter {
  codigo?: string;
  modoAutenticacion?: string;
  nombre?: string;
  contrasenia?: string;
}
